import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    MenuItem
} from '@material-ui/core';

import { LibraryAdd as AddSiteCardIcon } from '@material-ui/icons';

import { useDispatch, useSelector } from 'react-redux';
import {
    createSiteCardAsync,
    createSiteCardFromFeatureAnalysisAsync
} from '../../../redux/site_card/Actions';

import SelectTextField from '../UI/SelectTextField';
import { startAnalysisAsync } from '../../../redux/analysis/Actions';
import DialogButton from '../UI/Dialog/DialogButton';

const propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

const defaultProps = {};

// Currently assuming that all validation is done before the dialog is opened
function RunAnalysisDialog({ open, onClose }) {
    const currentProject = useSelector(state => state.project.currentProject);
    const search = useSelector(state => state.search.search);
    const layerId = useSelector(state => state.search.searchArea.layerId);

    const analysisProfiles = useSelector(state => {
        const profileIds =
            state.user.features['analysis']?.layers?.find(l => l.layerId === layerId)
                ?.profiles || [];
        return state.lookups.uiData.analysisProfiles.filter(ap =>
            profileIds.includes(ap.id)
        );
    });

    const defaultAnalysisProfile = useSelector(state => {
        const defaultProfiles = state?.user?.prefs?.defaultAnalysisProfiles ?? [];
        const profile = defaultProfiles.find(
            profile => profile.layerId === layerId
        );

        if (profile) return profile.profileId;

        return analysisProfiles.length > 0 ? analysisProfiles[0].id : undefined;
    });

    const dispatch = useDispatch();
    function dispatchStartAnalysisAsync(profileId) {
        dispatch(startAnalysisAsync(currentProject.id, search.id, profileId));
    }

    const [analysis, setAnalysis] = useState(defaultAnalysisProfile);

    function runAnalysis() {
        dispatchStartAnalysisAsync(analysis);
        onClose();
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <DialogTitle disableTypography>
                <AddSiteCardIcon />
                <Typography variant="h4">Run Analysis</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <SelectTextField
                    label="Analysis Profile"
                    fullWidth
                    value={analysis}
                    onChange={e => setAnalysis(e.target.value)}
                    tooltip="A profile represents a collection of layers to analysis against. Our standard profile is based on the National Planning Policy Framework (NPPF)">
                    {analysisProfiles.map(profile => (
                        <MenuItem key={profile.id} value={profile.id}>
                            {profile.name}
                        </MenuItem>
                    ))}
                </SelectTextField>
            </DialogContent>
            <DialogActions>
                <DialogButton onClick={runAnalysis} variant="contained">
                    Run analysis
                </DialogButton>
                <DialogButton onClick={onClose} variant="outlined">
                    Cancel
                </DialogButton>
            </DialogActions>
        </Dialog>
    );
}

RunAnalysisDialog.propTypes = propTypes;
RunAnalysisDialog.defaultProps = defaultProps;

export default RunAnalysisDialog;
